let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("823dU")).then(() => parcelRequire('d0O5A'));